import { render, staticRenderFns } from "./DpeAboutYou.vue?vue&type=template&id=04123d86&scoped=true"
import script from "./DpeAboutYou.vue?vue&type=script&lang=js"
export * from "./DpeAboutYou.vue?vue&type=script&lang=js"
import style0 from "./DpeAboutYou.vue?vue&type=style&index=0&id=04123d86&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "04123d86",
  null
  
)

export default component.exports